<form>
  <div class="row form-row mt-5">
    <div class="col">
      <div class="form-floating">
        <input [ngModelOptions]="{standalone: true}" #autocompleteInput type="text" class="form-control mb-0"
          id="addressCtrl" placeholder="Type your Address"
          [class.is-valid]="isGoogleAddressFilled() && hasDeliveryAddressCoverage()" (input)="changeAddress()"
          [(ngModel)]="queryString" />
        <label for="addressCtrl">* Address</label>
        @if (hasDeliveryAddressCoverage()) {
        <div class="valid-tooltip animated fadeIn">
          This address is in our delivery area!
        </div>
        }
        @if (!hasDeliveryAddressCoverage() && isGoogleAddressFilled()) {
        <div class="invalid-tooltip animated fadeIn">
          Oops! Your address isn't in our delivery zone.
        </div>
        }
        @if (isLoadingContent()) {
        <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
        }
      </div>
    </div>
  </div>
  @if (hasDeliveryAddressCoverage() && isGoogleAddressFilled()) {
  <div class="row form-row animated fadeInDown">
    <div class="col">
      <div class="form-floating">
        <input type="text" class="form-control" maxlength="100" name="additionalAddress"
          [ngModel]="deliveryAddress().additionalAddress"
          (ngModelChange)="updateDeliveryAddress({additionalAddress: $event })"
          placeholder="Type your additional address information" />
        <label for="additionalAddressCtrl">Additional address information</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating">
        <input type="text" class="form-control" name="zipCode" [ngModel]="deliveryAddress().zipCode"
          (ngModelChange)="updateDeliveryAddress({zipCode: $event })" placeholder="Type your ZIP Code"
          [class.is-valid]="isGoogleAddressFilled() && hasDeliveryAddressCoverage()" required minlength="5" />
        <label for="zipCodeCtrl">* ZIP Code</label>
        @if (isCheckContinue() && !deliveryAddress().zipCode) {
        <div class="invalid-feedback d-block">
          <i class="fas fa-xmark"></i>
          This field is required
        </div>
        }
        @if (isCheckContinue() && deliveryAddress().zipCode && ((deliveryAddress().zipCode?.length ?? 0) < 5)) { <div
          class="invalid-feedback d-block">
          <i class="fas fa-xmark"></i>
          Please provide a valid ZIP Code
      </div>
      }
    </div>
  </div>
  </div>

  <div class="row form-row animated fadeInDown">
    <div class="col">
      <div class="form-floating">
        <textarea class="form-control" placeholder="Leave your delivery notes here" maxlength="150"
          name="deliveryNotess" [ngModel]="deliveryAddress().deliveryNotes"
          (ngModelChange)="updateDeliveryAddress({deliveryNotes: $event})" style="height: 100px"></textarea>
        <label for="deliveryNotesCtrl">Delivery Notes</label>
      </div>

    </div>
  </div>
  }
</form>
